import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { __ACT_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { ValoreDominioVO } from 'shell/models/act-wizard';
import { HttpResponse } from 'shell/models/http-response';
import { ItemVM } from 'shell/view-models/item';

interface ListStatesDeclarationsProps {
  disabled?: boolean;
  required?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  error?: boolean;
  isSmallSize?: boolean;
}

const ListStatesDeclarationsComponent = ({
  disabled,
  required,
  onChange,
  value,
  error,
  isSmallSize = false,
}: ListStatesDeclarationsProps): React.ReactElement => {
  const [states] = useHttpFetch<HttpResponse<Array<ValoreDominioVO>>, Array<ItemVM>>(
    `${__ACT_API_URL__}/valori-dominio-atti/id-dominio/13`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
      },
      transformer: (response) =>
        ((response.data.payload || []) as Array<ValoreDominioVO>).map((item) => ({
          id: item.key?.idValore,
          value: item.descrizioneBreveValore,
        })) as Array<ItemVM>,
    }
  );

  const statesData: Array<ItemVM> = (states.data || []) as Array<ItemVM>;

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id="state-label">
        {required ? 'Stato dichiarazione *' : 'Stato dichiarazione'}
      </InputLabel>
      <PmiSelect
        labelId="state-label"
        id="state"
        name="state"
        value={value}
        label={required ? 'Stato dichiarazione *' : 'Stato dichiarazione'}
        onChange={onChange}
        disabled={disabled}
        error={error}
        size={isSmallSize ? 'small' : undefined}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {statesData?.map((state: ItemVM) => (
          <MenuItem key={state.id} value={state.id}>
            {state.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ListStatesDeclarationsComponent.displayName = 'List States Declarations component';

const ListStatesDeclarations = memo(ListStatesDeclarationsComponent);

export default ListStatesDeclarations as typeof ListStatesDeclarationsComponent;
